<template>
<div>
<div class="sign_out_bj">
    <div class="sign_logo">
      <img src="static/images/logo.png" alt="" />
        <!-- 山东泽众电子科技有限公司 -->
    </div>
    <div class="sign_con" v-if="sendsystem">        
      <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
        <ul class="sign_list">
            <li class="" >
                <div class="identity"><i class="name">账号：</i></div>
                
                <FormItem prop="userName">
                    <input v-model="form.userName" value placeholder="请输入账号" />
                    </input>
                </FormItem>
            </li>
            <li class="">
                <div class="identity"><i class="password">密码：</i></div>
                <FormItem prop="password">
                    <input type="password" v-model="form.password" placeholder="请输入密码">
                    </input>
                </FormItem>
                </li>
            <li class="button">
                <FormItem>
                    <input class="button"  @click="handleSubmit" type="button" value="登录进入实验" placeholder="">
                </FormItem>
            </li>
        </ul>
     </Form>
    </div>
    <div  class="sign_con" v-else>
        <ul class="sign_list" style="margin: 115px 0 0 360px;">
            <li class="button">
                <input
                class="into"
                type="button"
                @click="EntrySystem()"
                value="进入系统"
                placeholder
                />
            </li>
            <li class="button">
                <input style="background: #c4c4c4;"
                class="logout"
                type="button"
                @click="Cancellation()"
                value="注销"
                placeholder
                />
            </li>
        </ul>
    </div>
</div>
<div class="Copyright" style="border-top: 0px solid #000000;">
      <p>
        <span v-show="pageInformationIsshow" v-html="versionNumber" style="color:#0182E0;font-weight: bold;"> 版本号：4.0.0</span>
      </p>
    </div>
</div>
</template>
<script>
import Qs from "qs";
import LoginForm from "@/components/loginForm/loginForm.vue";
import md5 from "js-md5";
import axios from "@/libs/api.request";
export default {
  data() {
    return {
      form: {
        userName: "",
        password: "",
      },
      sendsystem: true,
      show: true,
      versionNumber: "", //版本号
      code: "versionNumber",
      pageInformationIsshow: false,
    };
  },
  components: {
    // logincomponents,
    LoginForm,
  },
  methods: {
    ///登录状态判断
    loginStatus() {
      var sendurl = localStorage.getItem("sendurl");
      var token = localStorage.getItem("authToken");
      if (
        sendurl !== null &&
        sendurl !== undefined &&
        sendurl !== "" &&
        token !== null &&
        token !== undefined &&
        token !== ""
      ) {
        this.sendsystem = false;
        this.realname = localStorage.getItem("realname");
        this.getConfig();
      } else {
        this.Cancellation();
      }
    },
    //注销
    Cancellation() {
      var Signout = localStorage.getItem("Signout");
      var url = localStorage.getItem("url");
      localStorage.clear();
      localStorage.setItem("Signout", Signout);
      localStorage.setItem("url", url);
      this.sendsystem = true;
    },
    //点击登录
    handleSubmit() {
      localStorage.removeItem("userid");
      localStorage.removeItem("authToken");
      localStorage.removeItem("account");
      localStorage.removeItem("realname");
      localStorage.removeItem("systype");
      localStorage.removeItem("sendurl");

      //localStorage.remove();
      var userName = "";
      var password = "";
      var posturl = this.config.baseUrl.pro + "/login/apiLogin";
      password = md5(this.form.password);
      userName = this.form.userName.trim();
      let postdata = {
        User_Name: userName,
        Secretkey: password,
        rememberClient: true
      };
      //登录
      return axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          data: Qs.stringify(postdata)
        })
        .then((resp) => {
          console.log(resp);
          if (resp.status === 200) {
            var data = resp.data.result;
            if (data.success) {
              console.log(resp);
              localStorage.setItem("userid", data.data.user.id);
              localStorage.setItem("authToken", data.token);
              localStorage.setItem("account", data.data.user.user_Name);
              localStorage.setItem("realname", data.data.user.real_Name);
              localStorage.setItem("systype", data.data.sysType);
              localStorage.setItem("sendurl", data.data.url);
              localStorage.setItem("UserRoleId", data.data.user.role_Id);
              this.sendsystem = false;

              this.getConfig();
              // alert(localStorage.getItem("sendurl"));
              // var sendurl = "/" + localStorage.getItem("sendurl");

              //   window.location.href = sendurl;
            } else {
              // this.$Message.error("登录失败，用户名或密码错误");
              this.$Modal.error({
                title: "提示",
                content: "登录失败，" + data.message,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
    getConfig() {
      var posturl = this.config.baseUrl.pro + "/Base_Config/apiGetConfigLoad";
      return axios
        .request({
          url: posturl,
          method: "POST",
          changeOrigin: true, //允许跨域
          headers: {
            "Content-Type": "application/x-www-form-urlenCoded",
            authToken: localStorage.getItem("authToken"),
            accept: "text/plain",
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            var data = resp.data.Result.Data;
            console.log(data);
            for (var i = 0; i < data.length; i++) {
              var item = data[i];
              localStorage.setItem(item.Code, item.Value);
              localStorage.removeItem("TeacherEnCode");
              localStorage.removeItem("TeacherEnCodes");
              localStorage.removeItem("StudentEnCode");
              localStorage.removeItem("StudentEnCodes");
            }
          } else {
            localStorage.clear();
            this.loginStatus();
          }
        })
        .catch((err) => {
          localStorage.clear();
          this.loginStatus();
          console.log(err);

          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
    //进入系统
    EntrySystem() {
      var sendurl = localStorage.getItem("sendurl");
      console.log(sendurl);
      window.location.href = sendurl;
    },
    //获取版本号
    getversionNumber() {
      var that = this;
      var posturl =
        this.config.baseUrl.pro +
        "/Base_Config/apiGetPagedBase_Configs?page=1&limit=1&KeyWord=" +
        this.code;
      axios
        .request({
          url: posturl,
          methods: "get",
          changeOrigin: true,
        })
        .then((resp) => {
          if (
            resp.data.result.data != null &&
            resp.data.result.data != undefined &&
            resp.data.result.data != ""
          ) {
            this.pageInformationIsshow = true;

            that.versionNumber = "版本号：" + resp.data.result.data[0].value;
            //this.versionNumber = resp.data.result.data[0].remark;
            //this.formData.id = resp.data.result.data[0].id;
          } else {
            this.pageInformationIsshow = false;
          }
        })
        .catch((err) => {
          this.$Message.error("数据加载失败：2" + err);
        });
    },
  },
  created() {
    this.loginStatus();
    this.getversionNumber();
    //this.handleSubmit();
    //this.getdate();
  },
};
</script>





// WEBPACK FOOTER //
// src/view/Login.vue